var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HomeHeader',{attrs:{"loading":_vm.loading,"loading-out":false},on:{"login":_vm.login,"logout":_vm.logout}}),_c('v-container',[_c('HomePrinting')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }